import { apiGet } from '@/api/http';

import type { PartnerProgram } from '@/types/recruiter';

export const getPartnerPrograms = (query: string = '') =>
  apiGet<PartnerProgram[]>(
    `${import.meta.env.VITE_API_URL}partner-programs/${query}`,
  );
